import { List, Show } from "../Components/index.js";

export default [
    {
        path: "/report/store",
        component: List,
        name: "report.property.store",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/store/:id/details",
        component: Show,
        name: "report.property.store.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/store/:id/product-details",
        component: Show,
        name: "report.property.store.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
